import { Component, HostListener, OnDestroy, ViewChild } from '@angular/core';
import { SiaTranslatePipe } from '@sia/shared';
import { DxDataGridComponent, DxDataGridModule } from 'devextreme-angular';
import {
  DxiColumnModule,
  DxoColumnChooserModule,
  DxoEditingModule,
  DxoFilterRowModule,
  DxoGroupPanelModule,
  DxoGroupingModule,
  DxoHeaderFilterModule,
  DxoLoadPanelModule,
  DxoLookupModule,
  DxoRemoteOperationsModule,
  DxoScrollingModule,
  DxoSearchPanelModule,
  DxoSelectionModule,
  DxoSortingModule,
} from 'devextreme-angular/ui/nested';
import { SiaGridConfigTab } from '../sia-grid-config-tab/sia-grid-config-tab.component';

@Component({
  selector: 'sia-grid-config-cols-part-two',
  templateUrl: './sia-grid-config-cols-part-two.component.html',
  styleUrls: ['./sia-grid-config-cols-part-two.component.scss'],
  providers: [
    {
      provide: SiaGridConfigTab,
      useExisting: SiaGridConfigColsPartTwoComponent,
    },
  ],
  standalone: true,
  imports: [
    DxDataGridModule,
    DxiColumnModule,
    DxoLookupModule,
    DxoEditingModule,
    DxoSelectionModule,
    DxoRemoteOperationsModule,
    DxoSortingModule,
    DxoColumnChooserModule,
    DxoLoadPanelModule,
    DxoHeaderFilterModule,
    DxoFilterRowModule,
    DxoSearchPanelModule,
    DxoGroupPanelModule,
    DxoGroupingModule,
    DxoScrollingModule,
    SiaTranslatePipe,
  ],
})
export class SiaGridConfigColsPartTwoComponent
  extends SiaGridConfigTab
  implements OnDestroy
{
  @ViewChild(DxDataGridComponent, { static: false })
  childDataGrid: DxDataGridComponent | undefined;

  @HostListener('window:unload')
  ngOnDestroy() {
    this.destroyDxComponent(this.childDataGrid, 'gridConfig2');
    super.ngOnDestroy();
  }
}
